import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetSerialNumberListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetSerialNumberListingAttempt', handleGetSerialNumberListing, api);
}

function* handleGetSerialNumberListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { filters: { serialNo, metalType } } = reduxState.gold.serialNumber.serialNumberListing;

    const response = yield* call([api, api.getSerialNumberListing], {
        authToken,
        serialNo: serialNo?.trim() === '' ? undefined : serialNo?.trim(),
        metalType: metalType === '' ? undefined : metalType,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetSerialNumberListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetSerialNumberListingSuccess({
            index: 0,
            maxIndex: 0,
            data: response.data ?? [],
        }));
    }
}
